import {
  FOC_TOUR_LABEL_PLANNING_P_TACTICS_MEETING,
  focFeedbackPopoverHtml,
} from '../focTourFeedback';
import {
  FOC_REQUIRED_DISPOSITION,
  focPlanningPRequirement,
  focPlanningPTourNavVisible,
  type FocPlanningPTourStepDef,
} from './focPlanningPTourTypes';
import { FOC_PLANNING_P_TACTICS_MEETING_TOUR_HREF } from './focPlanningPTourRegistry';

export {
  FOC_PLANNING_P_TACTICS_MEETING_TOUR_HREF,
  focPlanningPTourNavVisible,
};

/** Phase index 3 = Tactics Meeting. */
export const FOC_PLANNING_P_TACTICS_MEETING_TOUR_STEPS: FocPlanningPTourStepDef[] =
  [
    {
      id: 'sectionIntro',
      phaseIndex: 3,
      title: '10.6 Tactics Meeting',
      description:
        'The Tactics Meeting workspace is distinct from Prep for Tactics. It provides an IMH-aligned agenda, participant context, meeting progress, direct access to live deliverables, and a sequential facilitation model for what is needed now.',
    },
    focPlanningPRequirement({
      id: 'pp012',
      requirementId: 'FOC-PP-012',
      name: 'Tactics Meeting Mode',
      disposition: FOC_REQUIRED_DISPOSITION,
      phaseIndex: 3,
      tour: 'planning-stepper',
      description:
        'PRATUS presents a distinct Tactics Meeting phase that visibly differs from Prep for Tactics, with an IMH-aligned agenda, participant context, meeting progress, and direct access to live deliverables.',
    }),
    focPlanningPRequirement({
      id: 'pp012a',
      requirementId: 'FOC-PP-012a',
      name: 'Tactics Agenda',
      disposition: FOC_REQUIRED_DISPOSITION,
      phaseIndex: 3,
      tour: 'planning-agenda',
      showAgenda: true,
      description:
        'The meeting workspace supports the Coast Guard IMH Tactics Meeting sequence, including roll call and ground rules, Situation Unit Leader brief, objectives review, strategies and tactics, Operations (and Intelligence/Investigations when activated) organization, ICS 215 and 215A review, environmental issues, tactics-to-objectives validation, resource verification, logistics and finance issues, ICS 233 review/update, and meeting-schedule review/update.',
    }),
    {
      id: 'pp012Live',
      phaseIndex: 3,
      tour: 'ics215-card',
      widget: 'operationalPlanningWorksheet',
      title: 'Live Deliverables in Meeting',
      description:
        'During the Tactics Meeting, facilitators open live ICS 215, ICS 215A, and ICS 234 deliverables from the phase form rail so the agenda stays linked to working products while reviewing strategies, tactics, and resource feasibility.',
    },
    focPlanningPRequirement({
      id: 'pp012b',
      requirementId: 'FOC-PP-012b',
      name: 'Role-Appropriate Participation',
      disposition: FOC_REQUIRED_DISPOSITION,
      phaseIndex: 3,
      description:
        'PRATUS supports the required and recommended Tactics Meeting contributors without requiring every incident role to participate. Users not in the meeting retain access to their applicable role workspaces and contribution paths.',
    }),
    focPlanningPRequirement({
      id: 'pp012c',
      requirementId: 'FOC-PP-012c',
      name: 'Command-Decision Protection',
      disposition: FOC_REQUIRED_DISPOSITION,
      phaseIndex: 3,
      tour: 'planning-forms',
      widget: 'workAnalysisMatrix',
      description:
        'PRATUS prevents unauthorized modification of protected command decisions — including incident name, location, operational period, and approved incident objectives — during Prep for Tactics and the Tactics Meeting. Protected fields remain read-only without edit permission; this walkthrough does not change command decisions.',
    }),
    {
      id: 'focFeedback',
      title: 'FOC Feedback Notes',
      description: focFeedbackPopoverHtml(
        FOC_TOUR_LABEL_PLANNING_P_TACTICS_MEETING
      ),
    },
  ];

export function focPlanningPTacticsMeetingTourStepIds(): string[] {
  return FOC_PLANNING_P_TACTICS_MEETING_TOUR_STEPS.map((step) => step.id);
}
